import axiosInstance from "../../apiAxios/axiosInstance";


export const allactivestaff = async (payload) => {
  const response = await axiosInstance.post("/admin/all-active-staff", payload);
  return response.data;
};


export const getStaffList = async (payload) => {
  const response = await axiosInstance.post("/admin/staff-list",payload);
  return response.data;
};
export const getLogingStaffList = async (payload) => {
  const response = await axiosInstance.post("/admin/active-staff-list",payload);
  return response;
};

export const changeStaffPassword = (payload) =>{
 const response=   axiosInstance.post("/admin/staff-change-password", payload)
   return response
}

export const addStaff = async (data) => {
  const response = await axiosInstance.post(
    "/admin/staff-add",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};



export const getStaffDetails = (id) => {
  return axiosInstance.post("/admin/staff-show", {
    id: id,
  });
};
 

// Staff.Services.js

export const updateStaff = async (data) => {
  const { data: responseData } = await axiosInstance.post(
    "/admin/staff-update",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return responseData;
};

export const deleteStaff = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/staff-delete",
    payload
  );

  return response.data;
};
 


export const updateStaffStatus = (payload) =>{
 const response=   axiosInstance.post("/admin/staff-status-update", payload)
   return response
}



export const getStaffActivity = async(payload) => {
  const response= await axiosInstance.post("/admin/staff-activity-list",payload)
  return response.data
};
export const viewStaffActivity = (payload) => {

   const resposne=  axiosInstance.post("/admin/staff-activity-view",payload)

 return resposne
};



//today api for dashboard
export const getTodayNewStaffList = async(payload) => {
   const resposne= await axiosInstance.post("/admin/today-new-staff-list",payload)
 return resposne.data
};


